module.exports = __webpack_public_path__ + "static/floorplan_04-6b68dc5b77fc1547f9828fcf0dc64592.jpg";